export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  date: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  description: string;
  status: '更新中' | '已完结';
  rating: number;
  views: number;
  updateDate: string;
  chapters: ComicChapter[];
  tags: string[];
}

export const categories = [
  { name: '热门推荐', slug: 'hot' },
  { name: '恋爱言情', slug: 'romance' },
  { name: '奇幻冒险', slug: 'fantasy' },
  { name: '动作热血', slug: 'action' },
  { name: '悬疑推理', slug: 'mystery' },
  { name: '耽美BL', slug: 'bl' },
  { name: '搞笑日常', slug: 'comedy' },
  { name: '最新上架', slug: 'latest' },
];

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'she-wei-ming-yun',
    title: '社内命运',
    author: '金敏秀',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20and%20man%20in%20office%20attire%20with%20romantic%20atmosphere%2C%20soft%20warm%20lighting%2C%20watercolor%20texture%2C%20modern%20manhwa%20art%20style%2C%20clean%20composition%20with%20simple%20warm%20beige%20background&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: '恋爱言情',
    categorySlug: 'romance',
    description: '平凡的公司职员李智恩意外与公司最帅的部长展开了秘密办公室恋情。两个人在职场中的甜蜜互动与成长故事，展现了现代都市爱情的温暖与治愈。',
    status: '更新中',
    rating: 9.5,
    views: 1280000,
    updateDate: '2026-08-04',
    tags: ['办公室', '甜宠', '都市'],
    chapters: [
      { id: 'ch1-1', title: '第1话 意外的相遇', number: 1, date: '2026-01-15' },
      { id: 'ch1-2', title: '第2话 秘密的开始', number: 2, date: '2026-01-22' },
      { id: 'ch1-3', title: '第3话 心动的瞬间', number: 3, date: '2026-01-29' },
      { id: 'ch1-4', title: '第4话 暧昧的午餐', number: 4, date: '2026-02-05' },
    ],
  },
  {
    id: '2',
    slug: 'mo-fa-shao-nu-de-qiyue',
    title: '魔法少女的契约',
    author: '朴智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20artwork%20of%20a%20magical%20girl%20with%20flowing%20pink%20hair%20holding%20a%20glowing%20wand%2C%20fantasy%20setting%20with%20sparkles%20and%20magical%20effects%2C%20soft%20pastel%20color%20palette%2C%20detailed%20character%20design%2C%20clean%20warm%20cream%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    description: '普通高中生林小雅在一次意外中获得了魔法力量，与异世界的契约者签订契约后，开始了守护两个世界的冒险旅程。充满想象力的奇幻故事。',
    status: '更新中',
    rating: 9.3,
    views: 965000,
    updateDate: '2026-08-03',
    tags: ['魔法', '校园', '冒险'],
    chapters: [
      { id: 'ch2-1', title: '第1话 魔法觉醒', number: 1, date: '2026-02-10' },
      { id: 'ch2-2', title: '第2话 契约者', number: 2, date: '2026-02-17' },
      { id: 'ch2-3', title: '第3话 初次战斗', number: 3, date: '2026-02-24' },
      { id: 'ch2-4', title: '第4话 第二个世界', number: 4, date: '2026-03-03' },
    ],
  },
  {
    id: '3',
    slug: 'quan-li-you-xi',
    title: '权力游戏',
    author: '姜东元',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20illustration%20of%20a%20cool%20man%20in%20a%20black%20suit%20standing%20in%20a%20luxurious%20office%20with%20city%20skyline%20view%2C%20dark%20moody%20atmosphere%2C%20action%20thriller%20vibe%2C%20clean%20composition%20on%20neutral%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: '悬疑推理',
    categorySlug: 'mystery',
    description: '在韩国最大的企业集团中，各方势力为了争夺继承权而展开激烈角逐。主人公金泰亨以过人的智慧和胆识，在权力的漩涡中步步为营。',
    status: '已完结',
    rating: 9.7,
    views: 2100000,
    updateDate: '2026-07-15',
    tags: ['商战', '权谋', '都市'],
    chapters: [
      { id: 'ch3-1', title: '第1话 继承之战', number: 1, date: '2025-06-01' },
      { id: 'ch3-2', title: '第2话 暗流涌动', number: 2, date: '2025-06-08' },
      { id: 'ch3-3', title: '第3话 棋局初现', number: 3, date: '2025-06-15' },
    ],
  },
  {
    id: '4',
    slug: 'tian-mi-cheng-fa',
    title: '甜蜜惩罚',
    author: '李多海',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20romance%20manhwa%20style%20illustration%20of%20a%20couple%20sharing%20a%20tender%20moment%20in%20a%20cafe%2C%20warm%20cozy%20atmosphere%20with%20soft%20sunlight%2C%20gentle%20pastel%20colors%2C%20romantic%20and%20dreamy%20art%20style%2C%20simple%20cream%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: '恋爱言情',
    categorySlug: 'romance',
    description: '因为一次意外的接吻，高冷校草和活泼少女被迫开始了"惩罚式"的交往。从互相看不顺眼到渐渐心动，甜蜜又搞笑的校园爱情故事。',
    status: '更新中',
    rating: 9.4,
    views: 1560000,
    updateDate: '2026-08-05',
    tags: ['校园', '甜宠', '欢喜冤家'],
    chapters: [
      { id: 'ch4-1', title: '第1话 意外的吻', number: 1, date: '2026-03-01' },
      { id: 'ch4-2', title: '第2话 惩罚开始', number: 2, date: '2026-03-08' },
      { id: 'ch4-3', title: '第3话 心跳加速', number: 3, date: '2026-03-15' },
    ],
  },
  {
    id: '5',
    slug: 'an-ying-lie-ren',
    title: '暗影猎人',
    author: '崔正宇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cool%20Korean%20action%20manhwa%20illustration%20of%20a%20hunter%20with%20dark%20hair%20wielding%20a%20sword%20in%20a%20dungeon%20setting%2C%20dynamic%20pose%2C%20dramatic%20lighting%20with%20blue%20energy%20effects%2C%20modern%20game-like%20aesthetic%2C%20clean%20dark%20background%20with%20subtle%20texture&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: '动作热血',
    categorySlug: 'action',
    description: '在全球各地突然出现的地下城和怪物威胁人类生存的时代，被称为"猎人"的特殊能力者挺身而出。主人公韩世界从最低级猎人成长为最强猎人的热血故事。',
    status: '更新中',
    rating: 9.6,
    views: 1890000,
    updateDate: '2026-08-04',
    tags: ['战斗', '升级', '奇幻'],
    chapters: [
      { id: 'ch5-1', title: '第1话 觉醒之日', number: 1, date: '2025-09-01' },
      { id: 'ch5-2', title: '第2话 初次狩猎', number: 2, date: '2025-09-08' },
      { id: 'ch5-3', title: '第3话 地下城攻略', number: 3, date: '2025-09-15' },
      { id: 'ch5-4', title: '第4话 强者之路', number: 4, date: '2025-09-22' },
    ],
  },
  {
    id: '6',
    slug: 'chong-sheng-zhi-zun',
    title: '重生之尊',
    author: '吴成勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20majestic%20Korean%20manhwa%20artwork%20of%20a%20man%20in%20traditional%20martial%20arts%20robe%20with%20glowing%20energy%20surrounding%20him%2C%20ancient%20oriental%20fantasy%20setting%2C%20dramatic%20composition%2C%20golden%20and%20warm%20tones%2C%20epic%20atmosphere%2C%20simple%20warm%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    description: '一代武学宗师在渡劫失败后重生回到少年时代，带着前世的记忆和经验，他决定改写命运，弥补所有遗憾，成为真正的武道至尊。',
    status: '更新中',
    rating: 9.5,
    views: 1450000,
    updateDate: '2026-08-05',
    tags: ['重生', '武侠', '奇幻'],
    chapters: [
      { id: 'ch6-1', title: '第1话 渡劫失败', number: 1, date: '2025-10-01' },
      { id: 'ch6-2', title: '第2话 重回少年', number: 2, date: '2025-10-08' },
      { id: 'ch6-3', title: '第3话 新的开始', number: 3, date: '2025-10-15' },
    ],
  },
  {
    id: '7',
    slug: 'ta-de-mi-mi',
    title: '他的秘密',
    author: '郑秀晶',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20BL%20manhwa%20style%20illustration%20of%20two%20handsome%20men%20looking%20at%20each%20other%20with%20intense%20gaze%2C%20subtle%20romantic%20tension%2C%20soft%20lighting%2C%20elegant%20art%20style%2C%20minimal%20warm%20beige%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: '耽美BL',
    categorySlug: 'bl',
    description: '表面完美的公司前辈，私下却有着不为人知的秘密。新入职的后辈意外发现了这个秘密，两人的关系因此发生了微妙而深刻的变化。',
    status: '已完结',
    rating: 9.2,
    views: 890000,
    updateDate: '2026-06-20',
    tags: ['办公室', '治愈', '慢热'],
    chapters: [
      { id: 'ch7-1', title: '第1话 入职第一天', number: 1, date: '2025-07-01' },
      { id: 'ch7-2', title: '第2话 前辈的秘密', number: 2, date: '2025-07-08' },
      { id: 'ch7-3', title: '第3话 靠近的心', number: 3, date: '2025-07-15' },
    ],
  },
  {
    id: '8',
    slug: 'gao-xiao-ri-chang',
    title: '搞笑日常',
    author: '申惠善',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20comedy%20manhwa%20illustration%20of%20a%20girl%20with%20exaggerated%20funny%20expression%20and%20her%20pet%20cat%20causing%20chaos%2C%20bright%20and%20colorful%20art%20style%2C%20playful%20atmosphere%2C%20cartoonish%20expressions%2C%20simple%20warm%20cream%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: '搞笑日常',
    categorySlug: 'comedy',
    description: '一个普通女大学生的爆笑日常生活，从起床困难到考试周崩溃，再到与室友的欢乐相处。每一话都能让你笑到肚子疼的轻松喜剧。',
    status: '更新中',
    rating: 9.1,
    views: 1120000,
    updateDate: '2026-08-03',
    tags: ['搞笑', '校园', '日常'],
    chapters: [
      { id: 'ch8-1', title: '第1话 起床战争', number: 1, date: '2026-04-01' },
      { id: 'ch8-2', title: '第2话 食堂大冒险', number: 2, date: '2026-04-08' },
      { id: 'ch8-3', title: '第3话 考试周求生', number: 3, date: '2026-04-15' },
    ],
  },
  {
    id: '9',
    slug: 'xing-kong-xia-de-yue-ding',
    title: '星空下的约定',
    author: '刘智娜',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20manhwa%20scene%20of%20a%20couple%20sitting%20under%20a%20starry%20night%20sky%20on%20a%20hill%2C%20romantic%20and%20dreamy%20atmosphere%2C%20soft%20purple%20and%20blue%20twilight%20tones%2C%20emotional%20and%20tender%20moment%2C%20simple%20dark%20gradient%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: '恋爱言情',
    categorySlug: 'romance',
    description: '童年时在星空下许下的约定，十年后两人再次相遇却已物是人非。一段关于承诺、重逢与选择的感人爱情故事，温暖治愈。',
    status: '已完结',
    rating: 9.6,
    views: 1780000,
    updateDate: '2026-05-10',
    tags: ['青梅竹马', '重逢', '治愈'],
    chapters: [
      { id: 'ch9-1', title: '第1话 星空下的约定', number: 1, date: '2025-01-10' },
      { id: 'ch9-2', title: '第2话 十年之后', number: 2, date: '2025-01-17' },
      { id: 'ch9-3', title: '第3话 命运的重逢', number: 3, date: '2025-01-24' },
    ],
  },
  {
    id: '10',
    slug: 'shen-zhi-shi-jie',
    title: '神之世界',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20epic%20Korean%20fantasy%20manhwa%20illustration%20of%20a%20god-like%20figure%20floating%20above%20a%20mystical%20world%2C%20surrounded%20by%20ancient%20ruins%20and%20glowing%20energy%2C%20grandiose%20scale%2C%20warm%20golden%20light%2C%20mythological%20atmosphere%2C%20simple%20neutral%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    description: '当普通大学生陈凡获得神之系统后，他的生活发生了翻天覆地的变化。在神之世界中，他需要通过层层考验，解锁神力，最终成为新的世界之神。',
    status: '更新中',
    rating: 9.4,
    views: 1350000,
    updateDate: '2026-08-02',
    tags: ['系统', '升级', '神话'],
    chapters: [
      { id: 'ch10-1', title: '第1话 神的游戏', number: 1, date: '2025-11-01' },
      { id: 'ch10-2', title: '第2话 初入神域', number: 2, date: '2025-11-08' },
      { id: 'ch10-3', title: '第3话 力量考验', number: 3, date: '2025-11-15' },
    ],
  },
  {
    id: '11',
    slug: 'xue-zhi-hua',
    title: '血之花',
    author: '安孝燮',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20action%20manhwa%20artwork%20of%20a%20fierce%20female%20warrior%20with%20a%20sword%20standing%20among%20falling%20red%20flower%20petals%2C%20dramatic%20contrast%20of%20red%20blood%20and%20white%20flowers%2C%20intense%20and%20beautiful%20composition%2C%20minimal%20dark%20background&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: '动作热血',
    categorySlug: 'action',
    description: '在古代王朝的背景中，身为刺客的女主角为了复仇而踏上血路。精湛的武打场面与扣人心弦的剧情，让人欲罢不能的武侠动作巨作。',
    status: '更新中',
    rating: 9.3,
    views: 1020000,
    updateDate: '2026-08-04',
    tags: ['武侠', '复仇', '女性主角'],
    chapters: [
      { id: 'ch11-1', title: '第1话 灭门之夜', number: 1, date: '2025-12-01' },
      { id: 'ch11-2', title: '第2话 刺客之路', number: 2, date: '2025-12-08' },
      { id: 'ch11-3', title: '第3话 第一个目标', number: 3, date: '2025-12-15' },
    ],
  },
  {
    id: '12',
    slug: 'shen-tan-mo-si',
    title: '神探莫斯',
    author: '朴叙俊',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mystery%20Korean%20manhwa%20illustration%20of%20a%20sharp-looking%20detective%20in%20a%20trench%20coat%20holding%20a%20magnifying%20glass%2C%20noir%20atmosphere%20with%20rainy%20street%20background%2C%20suspenseful%20mood%2C%20classic%20detective%20aesthetic%2C%20simple%20warm%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: '悬疑推理',
    categorySlug: 'mystery',
    description: '天才侦探莫斯凭借敏锐的观察力和超凡的推理能力，破解一个又一个离奇案件。每一章都是一个独立的谜题，让读者跟随侦探一起推理。',
    status: '更新中',
    rating: 9.5,
    views: 1670000,
    updateDate: '2026-08-01',
    tags: ['侦探', '推理', '单元剧'],
    chapters: [
      { id: 'ch12-1', title: '第1话 消失的证物', number: 1, date: '2026-01-05' },
      { id: 'ch12-2', title: '第2话 密室之谜', number: 2, date: '2026-01-12' },
      { id: 'ch12-3', title: '第3话 双重身份', number: 3, date: '2026-01-19' },
    ],
  },
  {
    id: '13',
    slug: 'wen-nuan-de-shou',
    title: '温暖的手',
    author: '李圣经',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20Korean%20BL%20manhwa%20scene%20of%20two%20men%20gently%20holding%20hands%20in%20a%20cozy%20cafe%20setting%2C%20soft%20warm%20sunlight%20through%20window%2C%20tender%20and%20emotional%20atmosphere%2C%20delicate%20art%20style%2C%20simple%20cream%20background&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    category: '耽美BL',
    categorySlug: 'bl',
    description: '聋哑咖啡师与温柔作家的温暖相遇。不需要言语，两只手的触碰传递着最真挚的情感。一部关于包容、理解与爱的治愈系佳作。',
    status: '更新中',
    rating: 9.7,
    views: 720000,
    updateDate: '2026-08-05',
    tags: ['治愈', '慢热', '日常'],
    chapters: [
      { id: 'ch13-1', title: '第1话 沉默的咖啡师', number: 1, date: '2026-05-01' },
      { id: 'ch13-2', title: '第2话 指尖的温度', number: 2, date: '2026-05-08' },
      { id: 'ch13-3', title: '第3话 心与心的对话', number: 3, date: '2026-05-15' },
    ],
  },
  {
    id: '14',
    slug: 'xiao-yuan-jiang-hu',
    title: '校园江湖',
    author: '车银优',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20school%20action%20manhwa%20illustration%20of%20high%20school%20students%20in%20uniform%20with%20fighting%20stance%2C%20energetic%20and%20youthful%20vibe%2C%20comic-style%20action%20lines%2C%20bright%20school%20rooftop%20setting%2C%20simple%20warm%20cream%20background&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    category: '动作热血',
    categorySlug: 'action',
    description: '转学生入学第一天就被卷入学校帮派斗争，凭借超凡的身手和真诚的心，他一步步统一了混乱的校园，建立了属于自己的校园江湖。',
    status: '已完结',
    rating: 9.2,
    views: 1980000,
    updateDate: '2026-04-30',
    tags: ['校园', '格斗', '热血'],
    chapters: [
      { id: 'ch14-1', title: '第1话 转校生', number: 1, date: '2024-08-01' },
      { id: 'ch14-2', title: '第2话 初露锋芒', number: 2, date: '2024-08-08' },
      { id: 'ch14-3', title: '第3话 立威之战', number: 3, date: '2024-08-15' },
    ],
  },
  {
    id: '15',
    slug: 'mao-miao-ka-fei-ting',
    title: '猫咪咖啡厅',
    author: '孙艺珍',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cute%20Korean%20comedy%20manhwa%20illustration%20of%20a%20girl%20surrounded%20by%20adorable%20cats%20in%20a%20cozy%20cat%20cafe%2C%20fluffy%20cats%20playing%20around%2C%20warm%20and%20inviting%20interior%2C%20playful%20and%20heartwarming%20atmosphere%2C%20simple%20cream%20background&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    category: '搞笑日常',
    categorySlug: 'comedy',
    description: '失业女孩在猫咪咖啡厅找到了新的人生方向。每天与可爱的猫咪和有趣的客人们相处，生活中充满了温馨与欢乐。喵星人爱好者的必看之作。',
    status: '更新中',
    rating: 9.0,
    views: 760000,
    updateDate: '2026-08-03',
    tags: ['猫', '治愈', '日常'],
    chapters: [
      { id: 'ch15-1', title: '第1话 猫与失业者', number: 1, date: '2026-06-01' },
      { id: 'ch15-2', title: '第2话 第一天上班', number: 2, date: '2026-06-08' },
      { id: 'ch15-3', title: '第3话 猫咪大作战', number: 3, date: '2026-06-15' },
    ],
  },
  {
    id: '16',
    slug: 'hei-an-zhong-de-guang',
    title: '黑暗中的光',
    author: '金秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20suspenseful%20Korean%20thriller%20manhwa%20artwork%20of%20a%20person%20walking%20through%20a%20dark%20alley%20with%20a%20single%20streetlamp%20creating%20dramatic%20light%2C%20noir%20cinematic%20atmosphere%2C%20mysterious%20and%20tense%20mood%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-16&orientation=portrait',
    category: '悬疑推理',
    categorySlug: 'mystery',
    description: '在一个犯罪率极高的城市中，正义的检察官与黑暗势力展开了一场惊心动魄的较量。每一次庭审都是一场战争，每一个案件背后都隐藏着惊天秘密。',
    status: '更新中',
    rating: 9.4,
    views: 1230000,
    updateDate: '2026-08-04',
    tags: ['犯罪', '法律', '悬疑'],
    chapters: [
      { id: 'ch16-1', title: '第1话 新来的检察官', number: 1, date: '2026-02-01' },
      { id: 'ch16-2', title: '第2话 第一个案子', number: 2, date: '2026-02-08' },
      { id: 'ch16-3', title: '第3话 暗处的敌人', number: 3, date: '2026-02-15' },
    ],
  },
  {
    id: '17',
    slug: 'chuan-yue-yi-shi-jie',
    title: '穿越异世界',
    author: '韩志旼',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20colorful%20Korean%20isekai%20fantasy%20manhwa%20illustration%20of%20a%20modern%20person%20falling%20through%20a%20magical%20portal%20into%20a%20fantasy%20world%2C%20vibrant%20medieval%20fantasy%20setting%2C%20adventure%20and%20wonder%20atmosphere%2C%20simple%20warm%20cream%20background&width=400&height=560&seq=comic-cover-17&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    description: '普通上班族在加班途中意外穿越到剑与魔法的异世界。凭借现代人的知识和智慧，他在这个充满危险与机遇的世界中闯出了一片天地。',
    status: '更新中',
    rating: 9.3,
    views: 1340000,
    updateDate: '2026-08-05',
    tags: ['穿越', '异世界', '冒险'],
    chapters: [
      { id: 'ch17-1', title: '第1话 加班到异世界', number: 1, date: '2026-03-01' },
      { id: 'ch17-2', title: '第2话 剑与魔法', number: 2, date: '2026-03-08' },
      { id: 'ch17-3', title: '第3话 冒险者公会', number: 3, date: '2026-03-15' },
    ],
  },
  {
    id: '18',
    slug: 'ying-hua-lian-ai',
    title: '樱花恋爱',
    author: '赵宝儿',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20scene%20of%20a%20couple%20walking%20under%20blooming%20cherry%20blossom%20trees%20in%20spring%2C%20pink%20petals%20falling%20gently%2C%20dreamy%20pastel%20color%20palette%2C%20youthful%20and%20fresh%20atmosphere%2C%20simple%20cream%20background&width=400&height=560&seq=comic-cover-18&orientation=portrait',
    category: '恋爱言情',
    categorySlug: 'romance',
    description: '在樱花盛开的季节，大学新生李樱花邂逅了温柔学长，展开了一段如樱花般美丽又短暂的初恋故事。春日限定的浪漫纯爱。',
    status: '更新中',
    rating: 9.1,
    views: 870000,
    updateDate: '2026-08-02',
    tags: ['校园', '纯爱', '青春'],
    chapters: [
      { id: 'ch18-1', title: '第1话 樱花树下的你', number: 1, date: '2026-04-01' },
      { id: 'ch18-2', title: '第2话 图书馆邂逅', number: 2, date: '2026-04-08' },
      { id: 'ch18-3', title: '第3话 初次约会', number: 3, date: '2026-04-15' },
    ],
  },
  {
    id: '19',
    slug: 'ba-wang-zhi-lu',
    title: '霸王之路',
    author: '张东健',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20intense%20Korean%20action%20manhwa%20illustration%20of%20a%20powerful%20warrior%20with%20scarred%20face%20leading%20an%20army%2C%20epic%20battlefield%20background%20with%20flags%20and%20smoke%2C%20dramatic%20and%20heroic%20composition%2C%20warm%20earth%20tones%2C%20simple%20warm%20background&width=400&height=560&seq=comic-cover-19&orientation=portrait',
    category: '动作热血',
    categorySlug: 'action',
    description: '乱世之中，一个出身低微的少年凭借无双的武艺和过人的谋略，一步步成长为一代霸王。史诗般的战争场面与权谋斗争交织。',
    status: '已完结',
    rating: 9.6,
    views: 2230000,
    updateDate: '2026-03-15',
    tags: ['战争', '历史', '权谋'],
    chapters: [
      { id: 'ch19-1', title: '第1话 少年立志', number: 1, date: '2024-01-01' },
      { id: 'ch19-2', title: '第2话 初入军营', number: 2, date: '2024-01-08' },
      { id: 'ch19-3', title: '第3话 首战告捷', number: 3, date: '2024-01-15' },
    ],
  },
  {
    id: '20',
    slug: 'wo-de-jian-ling-zhen-me-zhe-me-ke-ai',
    title: '我的剑灵怎么这么可爱',
    author: '金裕贞',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20comedy%20fantasy%20manhwa%20illustration%20of%20a%20young%20swordsman%20with%20a%20tiny%20cute%20floating%20sword%20spirit%20companion%2C%20hilarious%20contrast%20between%20serious%20warrior%20and%20adorable%20spirit%2C%20bright%20and%20playful%20art%20style%2C%20simple%20warm%20cream%20background&width=400&height=560&seq=comic-cover-20&orientation=portrait',
    category: '搞笑日常',
    categorySlug: 'comedy',
    description: '立志成为最强剑士的少年意外唤醒了一只会说话的可爱剑灵。然而这个剑灵除了卖萌什么都不会！搞笑又温馨的冒险日常就此展开。',
    status: '更新中',
    rating: 9.4,
    views: 980000,
    updateDate: '2026-08-05',
    tags: ['奇幻', '搞笑', '萌系'],
    chapters: [
      { id: 'ch20-1', title: '第1话 剑灵觉醒', number: 1, date: '2026-05-15' },
      { id: 'ch20-2', title: '第2话 卖萌大法', number: 2, date: '2026-05-22' },
      { id: 'ch20-3', title: '第3话 第一次组队', number: 3, date: '2026-05-29' },
    ],
  },
];

export const hotComicIds = ['1', '3', '5', '6', '9', '12', '13', '19'];
export const latestComicIds = ['4', '17', '20', '11', '2', '16', '8', '15'];